import React, { useEffect, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getReducedSchoolsByMultiSchool, getSchool } from '../../actions/schoolsActions'
import { addProfileTypeSelection } from '../../actions/selectionsActions'
import Swal from 'sweetalert2'
import SelectionForm from '../../components/forms/selections/SelectionForm'

export default function CreateSelection() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {school, schools} = useSelector(state=>state.schools)
    const {resultselection} = useSelector(state=>state.selections)

    const [formState, setFormState] = useState({
        started: false,
        publicData: true,
        school: null,
        step: 1
	})

    useEffect(() => {
        if(client){
            if (client.rol === 'MultiSchool'){
                dispatch(getReducedSchoolsByMultiSchool(client?.id))
            } else {
                dispatch(getSchool(client?.id))
            }
        }
    },[dispatch, t, client])

    const verifySchool = () => {
        if(!formState?.school){
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.schoolError')
            }).then(() => {
                return false
            })
        }else{
            return true
        }
    }

    const handleSubmit = (e)=>{
        e.preventDefault()
        if (formState.title && formState.incorporationDate && formState.title.trim() !== "" && formState.incorporationDate.trim() !== "") {
            if (client.rol === 'MultiSchool'){
                if (verifySchool()) {
                    dispatch(addProfileTypeSelection({...formState, school: formState?.school?.value}, formState?.school?.value))
                }
            } else {
                dispatch(addProfileTypeSelection(formState,school._id))
            }
        } else {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('selection.formError')
            }).then(() => {
                return false
            })
        }
    }

    useEffect(() => {
        if(resultselection && resultselection.message){
            switch (resultselection.message) {
                case 'successaddselection':
                    if (client.rol === 'MultiSchool'){
                        navigate('/multischool/editprocess/' + resultselection.selection._id)
                    } else {
                        navigate('/school/editprocess/' + resultselection.selection._id)
                    }
                    break;
                default:
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('selection.erroraddselection')
                    })
                    break;
            }
            dispatch({
                type: 'SELECTION_RESET_RESULT'
            })
        }
    // eslint-disable-next-line
    },[resultselection])

    return (
        <>
            <Container className='cuerpo'>
                <div className="mb-4">
                    <div className="d-flex align-items-center">
                        <img src="/images/menus/processes.svg" alt="Procesos" className='me-3'/>
                        <h1>{t('selection.programtitle')}</h1>
                    </div>
                </div>
                <Card className='mb-5 sombra'>
                    <Card.Body className='px-5 pt-5'>
                        <SelectionForm
                            state={formState}
                            setState={setFormState}
                            submit={handleSubmit}
                            isMultiSchool={client?.rol === 'MultiSchool'}
                            schoolsOptions={schools?.map(school => ({value: school.id, label: school.name})) || []}
                        />
                    </Card.Body>
                </Card>
            </Container>
        </>
    )
}